import { matchPath } from 'react-router-dom';

export const getJobBoardBasePath = (pathname, boardType) => {
  const match = matchPath(pathname, {
    path: '/:userType/candidateList/:boardType',
    exact: false
  });
  return match ? match.url : pathname;
};

export const constructSearchPath = (basePath, params) => {
  const queryString = new URLSearchParams(params).toString();
  return `${basePath}/results?${queryString}`;
};

export const constructCandidatePath = (basePath, candidateId) => {
  return `${basePath}/results/candidate/${candidateId}`;
};

export const constructComparePath = (basePath, candidateIds) => {
  const queryString = new URLSearchParams({ candidates: candidateIds.join(',') }).toString();
  return `${basePath}/compare?${queryString}`;
};

export const parseSearchParams = (search) => {
  const params = new URLSearchParams(search);
  const values = {};
  for (const [key, value] of params.entries()) {
    values[key] = value;
  }
  return values;
};

export const parseCompareParams = (search) => {
  const params = new URLSearchParams(search);
  return params.get('candidates')?.split(',') || [];
}; 